/* tslint:disable */
/* eslint-disable */
/**
 * Pickway API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SmartroomAccessStatus {
    Pending = 'PENDING',
    Active = 'ACTIVE',
    Used = 'USED'
}

export function SmartroomAccessStatusFromJSON(json: any): SmartroomAccessStatus {
    return SmartroomAccessStatusFromJSONTyped(json, false);
}

export function SmartroomAccessStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmartroomAccessStatus {
    return json as SmartroomAccessStatus;
}

export function SmartroomAccessStatusToJSON(value?: SmartroomAccessStatus | null): any {
    return value as any;
}

